// Theme: celestial-yellow
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'celestial-yellow',
  name: 'CELESTIAL YELLOW',
  tagline: 'CELESTIAL YELLOW',
  description: 'Dourado estelar quente e radiante, em base comum sem efeitos.',
  category: 'system-core',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#3A2F00', '#4A3D00', '#FFD95A', '#FFF8DC'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '8px',
      '--shadow-card': '0 8px 20px rgba(0, 0, 0, 0.20)',
      '--shadow-card-active': '0 10px 24px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-celestial-yellow'
  },
  colorVars: {
    '--accent': '#FFD95A',
    '--accent-foreground': '#3A2F00',
    '--background': '#3A2F00',
    '--border': '#9A8520',
    '--card': '#4A3D00',
    '--card-border-active': 'rgba(255, 217, 90, 0.35)',
    '--card-completed': '#3F3400',
    '--card-foreground': '#FFF8DC',
    '--card-glow': 'rgba(255, 217, 90, 0.08)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#FFF8DC',
    '--hold-fill': '#FFD95A',
    '--input': '#9A8520',
    '--modal-bg': '#3A2F00',
    '--modal-border': '#9A8520',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--muted': '#9A8520',
    '--muted-foreground': '#FFF8DC',
    '--nav-active': '#FFD95A',
    '--nav-bg': '#4A3D00',
    '--popover': '#4A3D00',
    '--popover-foreground': '#FFF8DC',
    '--primary': '#FFD95A',
    '--primary-foreground': '#3A2F00',
    '--ring': '#FFD95A',
    '--secondary': '#9A8520',
    '--secondary-foreground': '#FFF8DC',
    '--streak': '#FFD95A',
    '--success': '#22c55e',
    '--success-foreground': '#3A2F00',
    '--xp': '#FFD95A',
    '--xp-bg': '#4A3D00'
  },
  resolvedVars: {
    '--accent': '#FFD95A',
    '--accent-foreground': '#3A2F00',
    '--accent-foreground-hsl': '49 100% 11%',
    '--accent-foreground-oklch': 'from #3A2F00 l c h',
    '--accent-hsl': '46 100% 68%',
    '--accent-oklch': 'from #FFD95A l c h',
    '--background': '#3A2F00',
    '--background-hsl': '49 100% 11%',
    '--background-oklch': 'from #3A2F00 l c h',
    '--border': '#9A8520',
    '--border-hsl': '50 66% 36%',
    '--border-oklch': 'from #9A8520 l c h',
    '--border-w': '1px',
    '--card': '#4A3D00',
    '--card-border-active': 'rgba(255, 217, 90, 0.35)',
    '--card-completed': '#3F3400',
    '--card-completed-hsl': '50 100% 12%',
    '--card-completed-oklch': 'from #3F3400 l c h',
    '--card-foreground': '#FFF8DC',
    '--card-foreground-hsl': '48 100% 93%',
    '--card-foreground-oklch': 'from #FFF8DC l c h',
    '--card-glow': 'rgba(255, 217, 90, 0.08)',
    '--card-hsl': '49 100% 15%',
    '--card-oklch': 'from #4A3D00 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FFF8DC',
    '--foreground-hsl': '48 100% 93%',
    '--foreground-oklch': 'from #FFF8DC l c h',
    '--hold-fill': '#FFD95A',
    '--hold-fill-hsl': '46 100% 68%',
    '--hold-fill-oklch': 'from #FFD95A l c h',
    '--input': '#9A8520',
    '--input-hsl': '50 66% 36%',
    '--input-oklch': 'from #9A8520 l c h',
    '--modal-bg': '#3A2F00',
    '--modal-bg-hsl': '49 100% 11%',
    '--modal-bg-oklch': 'from #3A2F00 l c h',
    '--modal-border': '#9A8520',
    '--modal-border-hsl': '50 66% 36%',
    '--modal-border-oklch': 'from #9A8520 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--muted': '#9A8520',
    '--muted-foreground': '#FFF8DC',
    '--muted-foreground-hsl': '48 100% 93%',
    '--muted-foreground-oklch': 'from #FFF8DC l c h',
    '--muted-hsl': '50 66% 36%',
    '--muted-oklch': 'from #9A8520 l c h',
    '--nav-active': '#FFD95A',
    '--nav-active-hsl': '46 100% 68%',
    '--nav-active-oklch': 'from #FFD95A l c h',
    '--nav-bg': '#4A3D00',
    '--nav-bg-hsl': '49 100% 15%',
    '--nav-bg-oklch': 'from #4A3D00 l c h',
    '--popover': '#4A3D00',
    '--popover-foreground': '#FFF8DC',
    '--popover-foreground-hsl': '48 100% 93%',
    '--popover-foreground-oklch': 'from #FFF8DC l c h',
    '--popover-hsl': '49 100% 15%',
    '--popover-oklch': 'from #4A3D00 l c h',
    '--primary': '#FFD95A',
    '--primary-foreground': '#3A2F00',
    '--primary-foreground-hsl': '49 100% 11%',
    '--primary-foreground-oklch': 'from #3A2F00 l c h',
    '--primary-hsl': '46 100% 68%',
    '--primary-oklch': 'from #FFD95A l c h',
    '--radius': '8px',
    '--ring': '#FFD95A',
    '--ring-hsl': '46 100% 68%',
    '--ring-oklch': 'from #FFD95A l c h',
    '--secondary': '#9A8520',
    '--secondary-foreground': '#FFF8DC',
    '--secondary-foreground-hsl': '48 100% 93%',
    '--secondary-foreground-oklch': 'from #FFF8DC l c h',
    '--secondary-hsl': '50 66% 36%',
    '--secondary-oklch': 'from #9A8520 l c h',
    '--shadow-card': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--shadow-card-active': '0 10px 24px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#FFD95A',
    '--streak-hsl': '46 100% 68%',
    '--streak-oklch': 'from #FFD95A l c h',
    '--success': '#22c55e',
    '--success-foreground': '#3A2F00',
    '--success-foreground-hsl': '49 100% 11%',
    '--success-foreground-oklch': 'from #3A2F00 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(46 100% 68% / 0.15)',
    '--xp': '#FFD95A',
    '--xp-bg': '#4A3D00',
    '--xp-bg-hsl': '49 100% 15%',
    '--xp-bg-oklch': 'from #4A3D00 l c h',
    '--xp-hsl': '46 100% 68%',
    '--xp-oklch': 'from #FFD95A l c h'
  }
}
